import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuthStoreV1 } from '@/stores/authStore_v1';
import { skillsAxios, skillsAuthHeaders } from '@/services/skills';
import { RUNS_ENDPOINT } from '@/services/reports';

export function useStopRun() {
  const queryClient = useQueryClient();
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id ?? null);

  return useMutation({
    mutationFn: (runId: string) =>
      skillsAxios.post(
        `${RUNS_ENDPOINT}/${encodeURIComponent(runId)}/stop`,
        {},
        { headers: skillsAuthHeaders() },
      ),
    onSuccess: (_data, runId) => {
      void queryClient.invalidateQueries({ queryKey: ['runs', orgId] });
      void queryClient.invalidateQueries({ queryKey: ['run', runId] });
    },
  });
}
